<template>
  <div class="dd-card_container">
    <div class="dd-card_header">
      <slot if="$slot.title" name="header"></slot>
      <h5 class="card-header_text">{{ title }}</h5>
    </div>
    <div class="dd-card_body">
      <slot if="$slot.body" name="body"></slot>
    </div>
  </div>
</template>
<script>
// 卡片组件，该组件仅仅实现标题和内容插槽，同时也开放标题插槽
export default {
  name: "DdCard",
  props: {
    title: {
      type: String,
      default: "卡片标题"
    },
    callback: {
      type: Function
    }
  }
};
</script>
<style lang="less">
.dd-card_container {
  margin-top: 10px;
  background-color: white;
  padding: 0 0px 10px 15px;
  box-shadow: 0 2px 3px #0000152b;
}
.dd-card_header {
  height: 55px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  align-items: center;
}
.card-header_text {
  font-size: 16px;
  line-height: 26px;
}
</style>
